export function accountValues() {
  const query = `{accountValues{
    futureValue, todayValue, lateValue, expiringValue,  balance, received
    }
}`;
  return query;
}

export function schoolStudentQuantity() {
  const query = `{schoolStudentQuantity
{
month, activeStudentQuantity, contractedStudentQuantity, dateInMilli

}
}`;
  return query;
}

export function receivablesByAccount() {
  const query = `{receivablesByAccount 
    {value, label}
}`;

  return query;
}

export function receivablesByCategory() {
  const query = `{receivablesByCategory 
    {value, label}
}`;

  return query;
}

export function dashboardClassOccupationData() {
  const query = `{dashBoardClassOccupationData 
    {occupation, capacity, classId, className}
}`;

  return query;
}

export function loadPermissionByUser() {
  return '{accessListByUser{listOfPermission{ key, children{key}}}}';
}

export function findEngagementMetrics() {
  return '{findEngagementMetrics{never, nothing, low, medium, high}}';
}
